import React from 'react';
import { Accordion } from '@mantine/core';

import OpsAreaCard from './OpsAreaCard';
import { OpsAreaHierarchy } from '../../codegen/graphql';

type Props = {
    opsAreas: OpsAreaHierarchy[];
};

function OpsAreas({ opsAreas }: Props) {
    return (
        <Accordion
            multiple
            classNames={{
                control: 'bg-primary-light hover:bg-primary-light/80',
                label: 'font-bold',
                content: 'px-1',
                item: 'border-none',
            }}
        >
            {opsAreas?.length ? (
                opsAreas.map(opsArea => (
                    <OpsAreaCard key={opsArea.id} opsArea={opsArea} />
                ))
            ) : (
                <div className="flex items-center justify-center">
                    <p className="font-medium">No Ops Areas Found</p>
                </div>
            )}
        </Accordion>
    );
}

export default OpsAreas;
